import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import LuxPlusLogoWrapper from 'luxPlus/components/LuxPlusLogoWrapper'
import type { ComponentProps } from 'react'
import React from 'react'
import { FormattedMessage } from 'react-intl'

type InheritedFormatCurrencyProps = Pick<ComponentProps<typeof FormatCurrency>, 'signDisplay'>

interface Props extends InheritedFormatCurrencyProps {
  memberPrice: number
  saleUnit?: string
  className?: string
}

/**
 * Displays the LuxPlus member price as a secondary caption-sized row,
 * matching the visual weight of PriceRowLuxPlusNonMemberPrice but with
 * LuxPlus branding (teal colour + logo).
 */
function PriceRowLuxPlusMemberPrice(props: Props) {
  const {
    memberPrice,
    saleUnit,
    signDisplay,
    className,
  } = props

  const sanitisedSaleUnit = saleUnit
    ? saleUnit.toLocaleLowerCase().replace(/^\//, '')
    : undefined
  const saleUnitLabel = sanitisedSaleUnit
    ? (/^(total|with)/.test(sanitisedSaleUnit) ? sanitisedSaleUnit : `/${sanitisedSaleUnit}`)
    : undefined

  const price = <b><FormatCurrency signDisplay={signDisplay} value={memberPrice} format="roundedDollar" /></b>
  const logo = <LuxPlusLogoWrapper height={8} />

  return <Caption
    variant="medium"
    colour="lux-plus"
    className={className}
    weight="normal"
  >
    {saleUnitLabel && <FormattedMessage
      id="T9-6hWxE6cZ5oFtqMhh9"
      defaultMessage="{price} {saleUnit} with\u00A0{logo}"
      description="LuxPlus member price with sale unit and logo"
      values={{ price, saleUnit: saleUnitLabel, logo }}
    />}
    {!saleUnitLabel && <FormattedMessage
      id="_tdOBZ_DmOkbWaccKr2M"
      defaultMessage="{price} with\u00A0{logo}"
      description="LuxPlus member price with logo"
      values={{ price, logo }}
    />}
  </Caption>
}

export default PriceRowLuxPlusMemberPrice
